export const DEFAULT_INDENT_SIZE = 'large';
export const dataHooks = {
    nestableListCount: 'nestableList-count',
    nestableListButton: 'nestableList-button',
};
export const indentSizes = ['small', 'medium', 'large'];
export const depthThresholds = {
    small: 20,
    medium: 32,
    large: 84,
};
//# sourceMappingURL=constants.js.map